import styles from "../styles/Footer.module.css"
const Footer = () => {
    return (
        <div className={styles.container}>
            
        </div>
    )
}

export default Footer
